export const enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
